import $ from "jquery";
import {
  EldmlTransform,
  getDefaultButtonClassName,
  getThemeButtonClassName,
} from "./EldmlTransform";

export class LinksTransform extends EldmlTransform {
  apply() {
    this.selector.find("a").each((_, element) => {
      const link = $(element);
      const href = link.attr("href");

      // link w nowej karcie
      if (href && href.indexOf("javascript:") === -1 && !link.attr("target")) {
        link.attr("target", "_top");
      }

      if (link.attr("button") === "true") {
        if (link.attr("background")) {
          link.addClass(getDefaultButtonClassName());
          link.attr("style", "background-color: " + link.attr("background"));
        } else if (link.attr("font-color")) {
          link.addClass(getDefaultButtonClassName());
        } else {
          const theme = link.attr("theme");
          link.addClass(getThemeButtonClassName(theme));
        }
      }

      if (this.transformer.mobile && href) {
        link.attr("href", null);
        link.on("click", (e) => {
          e.stopPropagation();
          e.preventDefault();
          this.transformer.onLinkClick?.(href);
        });
      }
    });
  }
}
